/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { Styles } from '../tableStyles';

function DisplayWaterQuality(props) {
  const { waterData } = props;
  return (
    <View>
      <View style={[Styles.table, { marginTop: 10, width:'90%' }]}>
        <View style={Styles.tableRow}>
          <View style={[
            Styles.tableHeader, { width: '100%', borderTopRightRadius: 6,
              borderTopLeftRadius: 6, borderRightWidth:0, alignItems: 'left', paddingLeft: 10 },
          ]}>
            <Text style={[Styles.tableCellHeader]}>Water Quality Data</Text>
          </View>
        </View>
        <View style={Styles.tableRow}>
          <View style={[
            Styles.tableRCText,
            { paddingLeft: 10, alignItems: 'left', width:'120%' }
          ]}>
            <Text style={Styles.tableCellHeader}>Ion</Text>
          </View>
          <View style={[
            Styles.tableRCText,
            { paddingLeft: 10, alignItems: 'left' }
          ]}>
            <Text style={Styles.tableCellHeader}>RO Feed</Text>
          </View>
          <View style={[
            Styles.tableRCText,
            { paddingLeft: 10, alignItems: 'left' }
          ]}>
            <Text style={Styles.tableCellHeader}>Brine</Text>
          </View>
          <View style={[
            Styles.tableRCText,
            { paddingLeft: 10, alignItems: 'left', borderRightWidth:0, width:'80%' }
          ]}>
            <Text style={Styles.tableCellHeader}>Units</Text>
          </View>
        </View>
        {Object.keys(waterData['RO Feed']).map((key, k_i) => {
          return (
            <View style={Styles.tableRow} key={k_i}>
              <View style={[
                Styles.tableRCText,
                { paddingLeft: 10, alignItems: 'left', width:'120%'},
                k_i === Object.keys(waterData['RO Feed']).length - 1 && { borderBottomWidth: 0 },
              ]}>
                <Text style={Styles.tableCell}>{key}</Text>
              </View>
              <View style={[
                Styles.tableRCText,
                k_i === Object.keys(waterData['RO Feed']).length - 1 && { borderBottomWidth: 0 },
              ]}>
                <Text style={Styles.tableCell}>{waterData['RO Feed']? ( typeof waterData['RO Feed'][key] === 'number' ? waterData['RO Feed'][key].toFixed(2) : waterData['RO Feed'][key]) : '-'}</Text>
              </View>
              <View style={[
                Styles.tableRCText,
                k_i === Object.keys(waterData['RO Feed']).length - 1 && { borderBottomWidth: 0 },
              ]}>
                <Text style={Styles.tableCell}>{waterData.Brine?  ( typeof waterData.Brine[key] === 'number' ? waterData.Brine[key].toFixed(2) : waterData.Brine[key]) : '-'}</Text>
              </View>
              <View style={[
                Styles.tableRCText, {borderRightWidth:0, width:'80%' },
                k_i === Object.keys(waterData['RO Feed']).length - 1 && { borderBottomWidth: 0 },
              ]}>
                <Text style={Styles.tableCell}>{key === 'CCPP'? 'ppm CaCO3': ((key === 'ph' || key === 'LSI' || key === 'SDI' || key === 'Ionic Strength')? '-': 'ppm')}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};
export default DisplayWaterQuality;